import { SCAN_JURISDICTIONS } from '/b2b/domains/constants';

export const getScanResultStatus = result => {
    if (result?.status) return result.status;

    const jurisdiction = result?.jurisdictions?.[SCAN_JURISDICTIONS.CALIFORNIA] || {};

    if (jurisdiction.status === 'error') return 'error';
    if (jurisdiction.status === 'warning') return 'warning';
    if (!result?.passed) return 'failed';

    return 'passed';
};
